<template>
  <div id="employes">
    <router-link to="/staff">
      <img class="imgicon" src="img/back.png" />
    </router-link>
    <h2>Liste des employés</h2>
    <div style="margin-top: 30px" class="row form-inline filtre">
      <div class="col-6">
        <CheckBoxGroup
          v-bind:data="fonctions"
          name="fonctions"
          title="Fonctions"
          idprop="id"
          nameprop="nom"
          @newselection="filter($event)"
        ></CheckBoxGroup>
      </div>
      <div class="col-6">
        <CheckBoxGroup
          v-bind:data="sites"
          name="sites"
          title="Sites"
          idprop="id"
          nameprop="nom"
          @newselection="filter($event)"
        ></CheckBoxGroup>
      </div>
    </div>
    <div class="ml-4 mt-2">
      <a href="javascript:" @click="generatePDF()">
        <img class="imgicon" src="img/pdf.png" /> Télécharger en PDF
      </a>
    </div>
    <b-pagination
      v-if="filteredEmployes.length > 0"
      class="mt-3"
      v-model="currentPage"
      :total-rows="filteredEmployes.length"
      :per-page="perPage"
      aria-controls="table-employes"
      align="fill"
      :limit="15"
      size="sm"
    >
      <template v-slot:page="{ page, active }">
        <span style="color:white;" v-if="active">{{ page }}</span>
        <span v-else>{{ page }}</span>
      </template>
    </b-pagination>
    <b-table
      responsive="sm"
      :items="filteredEmployes"
      :fields="fields"
      :per-page="perPage"
      :current-page="currentPage"
      class="mt-3"
      id="table-employes"
      small
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      sort-icon-left
    >
      <template v-slot:table-colgroup="scope">
        <col
          v-for="field in scope.fields"
          :key="field.key"
          :width="(field.key === 'nom' || field.key === 'prenom') ? '30%' : '13.3333%'"
        />
      </template>
      <template v-slot:cell(nom)="data">{{data.item.nom}}</template>
      <template v-slot:cell(prenom)="data">{{data.item.prenom}}</template>
      <template v-slot:cell(tel)="data">{{data.item.tel}}</template>
      <template v-slot:cell(fonction)="data">
        <span
          v-for="fonction in data.item.fonctions"
          v-bind:key="fonction"
        >{{fonctionsById[fonction].nom}}&nbsp;</span>
      </template>
      <template v-slot:cell(site)="data">{{sitesById[data.item.id_site].nom}}</template>
      <template v-slot:cell(admin)="data">
        <div>
          <b-form-checkbox
            :disabled="data.item.id === $store.state.user.id"
            :style="data.item.id === $store.state.user.id ? 'cursor: no-drop' : ''"
            @change="setAdmin(data.item)"
            v-model="data.item.admin"
            name="check-button"
            switch
          ></b-form-checkbox>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import api from "@/api";
import CheckBoxGroup from "../components/CheckBoxGroup";
import Swal from "sweetalert2";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000
});

export default {
  data() {
    return {
      fonctions: [],
      fonctionsById: [],
      sites: [],
      sitesById: [],
      employes: [],
      filters: {
        sites: [],
        fonctions: []
      },
      perPage: 15,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      fields: [
        { key: "nom", label: "Nom", sortable: true },
        { key: "prenom", label: "Prénom", sortable: true },
        { key: "tel", label: "Téléphone", sortable: false },
        { key: "fonction", label: "Fonction(s)", sortable: false },
        { key: "site", label: "Site", sortable: false },
        { key: "admin", label: "Accès Gest", sortable: false }
      ]
    };
  },
  components: {
    CheckBoxGroup
  },
  async created() {
    this.$store.commit("setLoading", true);
    this.fonctions = (await api.getFonctions()).data.fonctions;
    for (let fonction of this.fonctions) {
      this.fonctionsById[fonction.id] = fonction;
    }
    this.sites = (await api.getSites()).data.sites;
    for (let site of this.sites) {
      this.sitesById[site.id] = site;
    }
    this.employes = (await api.getEmployes()).data.employes;
    this.$store.commit("setLoading", false);
  },
  methods: {
    filter(e) {
      this.filters[e.name] = e.selected;
    },
    generatePDF() {
      api.pdf(`employes`, { filters: this.filters }, `employes`);
    },
    deleteEmploye(employe) {
      Swal.fire({
        title: `Supprimer ${employe.prenom} ${employe.nom} de la liste des employés?`,
        text: "Cette action est irreversible",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui",
        cancelButtonText: "Non"
      }).then(async result => {
        if (result.value) {
        }
      });
    },
    async setAdmin(employe) {
      let response = await api.setAdmin(employe.id, !employe.admin ? 1 : 0);
      Toast.fire({
        type: response.code === 200 ? "success" : "error",
        text: response.message
      });
    }
  },
  computed: {
    filteredEmployes() {
      return this.employes.filter(employe => {
        let sitematch = 0;
        for (let site of this.filters.sites) {
          if (site === employe.id_site) sitematch++;
        }
        let fonctionmatch = 0;
        for (let id_fonction of employe.fonctions) {
          for (let fonction of this.filters.fonctions) {
            if (fonction === id_fonction) fonctionmatch++;
          }
        }
        if (sitematch > 0 && fonctionmatch > 0) {
          return employe;
        }
      });
    }
  }
};
</script>